import React from 'react';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import { Button, Radio } from '../../../../Components/MUIs';

export const getColumnDefs1 = (props) => [
  {
    headerCheckboxSelection: true,
    field: 'no',
    headerName: 'NO',
    maxWidth: 100,
    cellStyle: {
      textAlign: 'right',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    editable: false,
    cellClass: 'delete-action-cell',
    cellRenderer: (params) => (
      <GridCheckBox
        params={params}
        DeleteNewRow={props.DeleteNewRow1}
        RestoreRow={props.RestoreRow1}
        gridRef={props.gridRef1}
        rowData={props.rowData1}
        selectedRowNosRef={props.selectedRowNosRef1}
        lastCheckedIndexRef={props.lastCheckedIndexRef1}
        handleRowSelection={props.handleRowSelection1}
      />
    ),
  },
  {
    field: 'PRO_ID',
    headerName: '프로그램ID',
    minWidth: 120,
    editable: false,
    cellRenderer: (e) => {
      if (!e.data) return null;
      if (e.data.PRO_ID) {
        return (
          <button
            type="button"
            onClick={() => props.popupClickEvent1?.(e)}
            style={{
              background: 'none',
              border: 'none',
              color: '#1976d2',
              cursor: 'pointer',
              textDecoration: 'underline',
              padding: 0,
              font: 'inherit',
            }}
          >
            {e.data.PRO_ID}
          </button>
        );
      }
      return (
        <Button
          size="small"
          name={'설정하기'}
          onClick={() => {
            props.popupClickEvent1?.(e);
          }}
        />
      );
    },
  },
  {
    field: 'PRO_CONTENT',
    headerName: '프로그램 설명',
    minWidth: 300,
    editable: true,
    flex: 1,
  },
  {
    field: 'PRO_DTL',
    headerName: '메뉴 상세코드',
    minWidth: 120,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'PRO_DTL_NM',
    headerName: '프로그램 상세',
    editable: true,
    minWidth: 300,
  },
  {
    field: 'SAVE_YN',
    headerName: '추가,저장 권한',
    minWidth: 120,
    cellRenderer: (e) => {
      return (
        <Radio
          value={e.value}
          onChange={(change) => e.setValue(change)}
          items={[
            { name: 'Y', value: 'Y' },
            { name: 'N', value: 'N' },
          ]}
        />
      );
    },
    editable: false,
    cellStyle: { textAlign: 'center' },
  },
  {
    field: 'DELETE_YN',
    headerName: '삭제 권한',
    minWidth: 120,
    cellRenderer: (e) => {
      return (
        <Radio
          value={e.value}
          onChange={(change) => e.setValue(change)}
          items={[
            { name: 'Y', value: 'Y' },
            { name: 'N', value: 'N' },
          ]}
        />
      );
    },
    editable: false,
    cellStyle: { textAlign: 'center' },
  },
  {
    field: 'PRINT_YN',
    headerName: '출력 권한',
    minWidth: 120,
    cellRenderer: (e) => {
      return (
        <Radio
          value={e.value}
          onChange={(change) => e.setValue(change)}
          items={[
            { name: 'Y', value: 'Y' },
            { name: 'N', value: 'N' },
          ]}
        />
      );
    },
    editable: false,
    cellStyle: { textAlign: 'center' },
  },
];

export const getColumnDefsModal = () => [
  {
    checkboxSelection: true,
    field: 'no',
    headerName: 'NO',
    minWidth: 50,
    editable: false,
  },
  {
    field: 'PRO_ID',
    headerName: '프로그램ID',
    minWidth: 120,
    editable: (params) => GridFunctions.isCellEditable(params),
  },
  {
    field: 'PRO_CONTENT',
    headerName: '프로그램 설명',
    minWidth: 300,
    flex: 1,
    editable: true,
  },
];
